
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/authors/[author]",
      function () {
        return require("private-next-pages/blog/authors/[author].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/authors/[author]"])
      });
    }
  